import { useApiFetch, useApiMutation } from '../api';

/**
 * Fetches all fleet invitations where this workspace is the invited party.
 */
export function useFleetInvitationsByInvitedWorkspace(workspaceId: number) {
  return useApiFetch(`/workspaces/${workspaceId}/fleet-invitations`, async (callApi) => {
    const response = await callApi((api) =>
      api.fleets.getV1FleetInvitations({ invitedWorkspaceIdIn: [workspaceId], limit: 1000 })
    );

    return response.data;
  });
}

export function useFleetInvitations() {
  return useApiFetch(`/fleet-invitations`, async (callApi) => {
    const response = await callApi((api) => api.fleets.getV1FleetInvitations({ limit: 1000 }));

    return response.data;
  });
}

export function useFleetInvitationsByFleetIds(fleetIds: number[]) {
  return useApiFetch(
    fleetIds.length > 0 ? `fleet-invitations/fleets/${fleetIds.join(',')}` : null,
    async (callApi) => {
      const response = await callApi((api) =>
        api.fleets.getV1FleetInvitations({
          fleetIdIn: fleetIds,
          limit: 1000,
        })
      );

      return response.data;
    }
  );
}

export function useFleetInvitationsByFleet(workspaceId: number, fleetId: number) {
  return useApiFetch(
    `/workspaces/${workspaceId}/fleets/${fleetId}/invitations`,
    async (callApi) => {
      const response = await callApi((api) =>
        api.fleets.getV1WorkspacesWorkspaceidFleetsFleetidInvitations({ workspaceId, fleetId })
      );

      return response.data;
    }
  );
}

export function useDeleteFleetInvitation(workspaceId: number, fleetId: number) {
  return useApiMutation(
    `/workspaces/${workspaceId}/fleets/${fleetId}/invitations`,
    async (callApi, invitationId: number) =>
      await callApi((api) =>
        api.fleets.deleteV1WorkspacesWorkspaceidFleetsFleetidInvitationsInvitationid({
          workspaceId,
          fleetId,
          invitationId,
        })
      )
  );
}
